import {Component, Input, OnChanges, SimpleChanges,ViewEncapsulation,Output, EventEmitter} from '@angular/core';
import { Http, Response } from '@angular/http';
import {SanitizeHtmlPipe} from 'app/utils/sanatize-pipe'
import * as cheerio from 'cheerio';
import {WindowRef} from 'app/utils/windowRef';
import {CategoryDataService} from "app/category/category-data.service";
declare var $:any;

let numInstances = 0;

@Component({
  selector: 'my-html',
  template: `<div  class="contentData" [innerHTML]="myVal | sanitizeHtml" attr.aria-label="{{title}}" *ngIf="myVal!=undefined"></div>`,
  //styleUrls: ['./../app.sass'],
  encapsulation: ViewEncapsulation.None,
  providers: [CategoryDataService]

})





export class MyHtml {
  private instanceId: number;
  private  _url = '';
  private _part = '';
  service: CategoryDataService;
  @Input()
  title: string;

  myVal: any = "";
  myExtra: any = "";
  _http: Http;
  _myHTML:string;

  @Output() userNav = new EventEmitter();

  @Input()
  mode: string = "myVal";

  @Input()
  set url(url: string){
      if(url==''){
        console.log('url is empty')
        this._url = null;
        this.myVal = ''
      }else{

          this._url = url;


      }

  }
  get url(): string {return this._url}

  @Input()
  set part(part: string){
    if(part==''){
      this._part = null;
    }else{

      if(this._part!=part) {
        console.log('new part',this._part,part)
        this._part = part;
        this.myVal = (this.mode=='myVal')? $('.pageData '+this._part).html() : $('.pageData '+this._part+" .outsideResults").html()

      }
    }

  }
  get part(): string {return this._part}





  constructor(http: Http, service: CategoryDataService) {
    console.log('HTML Contr')
    this._http = http;
    this.instanceId = numInstances++;
    this.service = service


    //winRef.nativeWindow['appGlobal'].test=this;
    //this.service = service;


  }



    ngAfterViewInit(){
        console.log('HTML View Done')
        //this.listReady=true;
    }





}








// WEBPACK FOOTER //
// ./src/app/utils/html.component.ts